import { isDefined } from "@clipboard-health/util-ts";
import { WorkplaceNoteIdentifier } from "@src/appV2/redesign/Workplace/constants";
import { useWorkplaceNotesParsed } from "@src/appV2/redesign/Workplace/useWorkplaceNotesParsed";

import type { ParkingContext } from "../types";

interface UseParkingInstructionsParams {
  facilityUserId?: string;
}

/**
 * Single-responsibility hook for parking instructions
 * Simple data fetching with clear return type
 */
export function useParkingInstructions({
  facilityUserId,
}: UseParkingInstructionsParams): ParkingContext {
  const {
    data: notes = {},
    isSuccess,
    isLoading,
  } = useWorkplaceNotesParsed(facilityUserId ?? "", {
    enabled: isDefined(facilityUserId) && facilityUserId.length > 0,
  });

  const instructions = isSuccess
    ? (notes[WorkplaceNoteIdentifier.PARKING_INSTRUCTIONS]?.note ?? undefined)
    : undefined;

  return {
    instructions,
    isLoading,
  };
}
